<template>
  <div class="container">
    <BaseFrame
      :breadcrumb="[
        {
          name: 'maintainPlanList',
          title: '养护/检定计划列表'
        },
        {
          name: 'maintainPlanMeasure',
          title: '计量器具检定结果维护'
        }
      ]"
      :btns="[
        {
          name: 'cancel',
          text: '取消',
        },
        {
          name: 'save',
          text: '保存',
          type: 'primary'
        },
        {
          name: 'submit',
          text: '提交',
          type: 'primary'
        }
      ]"
      @btn-click="onBtnClick"
    >
      <div slot="info">
        <div>计划编号：{{assertsCuringPlan.code}}</div>
        <div class="info-container">
          <div class="info-item">门店名称：{{assertsCuringPlan.storeName}}</div>
          <div class="info-item">创建时间：{{assertsCuringPlan.createTime}}</div>
          <div class="info-item">创建人：{{assertsCuringPlan.createUserName}}</div>
          <div class="info-item">计划状态：{{assertsCuringPlan.statusStr}}</div>
          <div class="info-item">设备类型：{{assertsCuringPlan.typeStr}}</div>
        </div>
      </div>

      <div slot="content">
        <lk-card title="录入养护结果">
          <lk-table border :columns="columns" :data="assertsCuringHistoryVOs" class="plan-table requireAssetAdd"/>
        </lk-card>
      </div>
    </BaseFrame>
  </div>
</template>

<script>
import BaseFrame from '../../components/frame/NewBaseFrame.vue';
import assets from '../../services/assets';
import utils from '../../libs/utils';
// import AnTable from '../../components/table';
import Uploader from '../../components/Uploader.vue';

export default {
  name: 'MeasureInput',
  components: {
    BaseFrame,
    // AnTable,
  },
  data() {
    return {
      id: '',
      assertsCuringPlan: {},
      purchaseReceiptImgInfoList: [],
      tempInput: '',
      assertsCuringHistoryVOs: [],
      columns: [
        {
          title: '设备编码',
          minWidth: 116,
          key: 'assertsCode',
        },

        {
          title: '设备名称',
          minWidth: 116,
          key: 'assertsName',
        },
        {
          title: '型号',
          minWidth: 116,
          key: 'unitType',
        },
        {
          title: '生产企业',
          minWidth: 116,
          key: 'manufacturer',
        },
        {
          title: '检测机构',
          minWidth: 116,
          key: 'inspectionMechanism',
          render: (h, { row, index }) => h('lk-input', {
            on: {
              'on-blur': (e) => {
                this.assertsCuringHistoryVOs[index].inspectionMechanism = e.target.value;
              },
            },
            props: {
              value: row.inspectionMechanism,
              maxlength: 50,
            },
          }),
        },
        {
          title: '检测完成时间',
          minWidth: 130,
          key: 'inspectionTime',
          render: (h, { row, index }) => h('lk-date-picker', {
            on: {
              'on-change': (value) => {
                this.assertsCuringHistoryVOs[index].inspectionTime = value;
              },
            },
            props: {
              value: row.inspectionTime,
              placeholder: '请选择',
              editable: false,
            },
          }),
        },
        {
          title: '检测结果',
          minWidth: 116,
          key: 'inspectionResult',
          render: (h, { row, index }) => {
            const optionArr = [
              h('lk-option',
                {
                  props: {
                    value: 1,
                  },
                }, '合格'),
              h('lk-option',
                {
                  props: {
                    value: 2,
                  },
                }, '限用'),
            ];
            return h('lk-select',
              {
                on: {
                  'on-change': (value) => {
                    this.assertsCuringHistoryVOs[index].inspectionResult = value;
                  },
                },
                props: {
                  value: row.inspectionResult,
                  placeholder: `${row.inspectionResultStr}`,
                },
              },
              optionArr);
          },
        },
        {
          title: '检测备注',
          minWidth: 116,
          key: 'curingDescription',
          render: (h, { row, index }) => h('lk-input', {
            on: {
              'on-change': (e) => {
                this.assertsCuringHistoryVOs[index].curingDescription = e.target.value;
              },
            },
            props: {
              value: row.curingDescription,
              maxlength: 50,
            },
          }),
        },
        {
          title: '检测报告',
          minWidth: 166,
          key: 'picUrl',
          render: (h, { row, index }) => h(Uploader, {
            on: {
              handle: (val) => {
                this.assertsCuringHistoryVOs[index].picUrl = val || '';
              },
            },
            props: {
              able: true,
              url: row.picUrl || '',
              // canDelete: true,
              // format: ['jpg', 'jpeg', 'gif', 'png', 'tiff', 'bmp', 'pdf', 'doc', 'docx', 'xls', 'xlsx'],
              // onFormatError() {
              //   this.$Message.error('只能上传图片（jpg/jpeg、gif、png、tiff、bmp类型）、pdf、word、excel！');
              // },
            },
          }),
        },
      ],
    };
  },
  methods: {
    resetTableData() {
      this.assertsCuringHistoryVOs = [];
    },
    resetInfo() {
      this.assertsCuringPlan = {};
    },
    onBtnClick(name) {
      if (name === 'cancel') {
        this.onCancel();
      } else if (name === 'save') {
        this.onSubmit('save');
      } else if (name === 'submit') {
        this.onSubmit('submit');
      }
    },
    onSubmit(flag) {
      // adapt data
      let addFunction = assets.savePlan;
      const assertsCuringPlan = {
        id: this.assertsCuringPlan.id,
        type: this.assertsCuringPlan.type,
      };
      let assertsCuringHistories = [];
      let resultFlag = false;
      if (flag === 'submit') {
        addFunction = assets.submitPlan;
      }
      const messages = [];
      this.assertsCuringHistoryVOs.forEach((item) => {
        if (!item.inspectionMechanism) {
          messages.push('检测机构不能为空！');
        }
        if (!item.inspectionTime) {
          messages.push('请选择检测完成时间！');
        }
        if (!item.inspectionResult) {
          messages.push('请选择检测结果！');
        }
        if (!item.curingDescription) {
          messages.push('请输入检测备注！');
        }
        if (!item.picUrl) {
          messages.push('请上传检测报告！');
        }
      });
      if (messages.length > 0) {
        this.$Message.error(messages[0]);
        return;
      }
      assertsCuringHistories = this.assertsCuringHistoryVOs.map((item) => {
        if (item.inspectionResult == 2 && !item.curingDescription) {
          resultFlag = true;
        }
        return {
          id: item.id,
          inspectionMechanism: item.inspectionMechanism,
          inspectionTime: utils.exchangeDate(item.inspectionTime),
          curingDescription: item.curingDescription,
          inspectionResult: item.inspectionResult,
          picUrl: item.picUrl,
        };
      });
      const data = {
        assertsCuringPlan,
        assertsCuringHistories,
      };
      if (resultFlag) {
        this.$Message.error('检测结果为限用时，需要填写检测备注！');
        return;
      }
      addFunction(data).then((res) => {
        const code = res.data.status;
        if (code === 200) {
          this.resetAll();
          this.jumpToList();
        } else {
          this.$Message.error(res.data.error);
        }
      });
      // reset
    },
    resetAll() {
      this.resetTableData();
      this.resetInfo();
    },
    jumpToList() {
      this.$router.push({
        name: 'maintainPlanList',
      });
    },
    onCancel() {
      this.resetAll();
      this.jumpToList();
    },
    getData() {
      if (!this.id) {
        return;
      }
      assets.planDetail({ id: this.id }).then((res) => {
        if (res.data.status === 200) {
          this.tableData = [];
          this.assertsCuringPlan = res.data.data.assertsCuringPlan;
          this.assertsCuringPlan.createTime = utils.formatTime(res.data.data.assertsCuringPlan.createTime, 'YYYY/MM/DD HH:mm');
          this.assertsCuringPlan.curingResultStr = res.data.data.assertsCuringPlan.curingResultStr ? res.data.data.assertsCuringPlan.curingResultStr : '';
          res.data.data.assertsCuringHistoryVOs.forEach((item) => {
            if (item.inspectionTime) {
              item.inspectionTime = utils.formatTime(item.inspectionTime, 'YYYY-MM-DD');
            } else {
              item.inspectionTime = '';
            }
          });
          this.assertsCuringHistoryVOs = res.data.data.assertsCuringHistoryVOs;
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
  },
  mounted() {
    const { id } = this.$route.query;
    this.id = id;
    this.getData();
  },
};
</script>
<style lang="less" scoped>
.temp-img{
  height: 80px;
  width: 80px;
}
.other-card{
  margin-top: 30px;
}
.rejectTable{
  margin-bottom: 16px;
}

</style>
